<template>
  <div>
    <ul class="timeline mb-5">
      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag"
              >Análisis y Desarrollo de Sistema de la Información</span
            >
            <span class="time-wrapper">
              <span class="time">2016 - 2017</span>
            </span>
          </div>
          <div class="desc">
            Egresado de la tecnología en análisis y desarrollo de sistemas de la
            información del
            <strong>Sena</strong>
            , ingresé en el 2016. En este trascurso te tiempo aprendí las bases
            del desarrollo web y móvil, me introduje a los lenguajes web como
            PHP usando los framework Codeingater y Laravel, Python usando
            Django, aplicando diseño web con Bootstrap, CSS3, JavaScript,
            desarrollo móvil en Android Studio, manejo de base de datos MySQL,
            Firebase, participando en SenaSoft 2018 en la ciudad de Cartago
            Valle en el área de desarrollo web.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo móvil Android Studio</span>
            <span class="time-wrapper">
              <span class="time">2017</span>
            </span>
          </div>
          <div class="desc">
            Curso práctico enfocado en el desarrollo móvil usando Android
            Studio, donde aprendí el uso de las diferentes Layouts, Fragmentes,
            lógica en Java, Material Design, consumo de datos SUGAR..
          </div>
        </div>
      </li>
      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo Web PHP Laravel</span>
            <span class="time-wrapper">
              <span class="time">2018</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas web usando el
            framework Laravel en su versión 5.5, comprendiendo y practicando
            temas como: Blade, Eloquent, MVC, relaciones HasMany, BelongsTo,
            BelongToMany, creación de APIs,
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo Web Angular</span>
            <span class="time-wrapper">
              <span class="time">2018</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas web usando el
            framework Angular , comprendiendo y practicando temas como:
            Componentes, Rutas, Estructuración de Proyectos, Servicios, Pipes,
            Material Angular.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo Web VUE</span>
            <span class="time-wrapper">
              <span class="time">2018</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas web usando el
            framework VUE, comprendiendo y practicando temas como:
            <strong>Implementación con Laravel</strong>, Componentes,
            Estructuración de Proyectos, VUEX, VueRouter, Vuetify.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo Web Django</span>
            <span class="time-wrapper">
              <span class="time">2019</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas web usando el
            Python con framework Django, comprendiendo y practicando temas como:
            Estructuración de Proyectos, admin de Django, Modelos, migraciones,
            sistema de plantillas, formularios, sesiones.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo móvil IONIC</span>
            <span class="time-wrapper">
              <span class="time">2019</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas móvil usando el
            Angular con framework ionic, comprendiendo y practicando temas como:
            Estructuración de Proyectos, diseño IONIC, Storage, Servicios,
            Conexión con Firebase, uso de funciones nativas del dispositivo
            (cámara, GPS, giroscopio).
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">Desarrollo Web React</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de sistemas móvil usando la
            librería React, comprendiendo y practicando temas como:
            Estructuración de Proyectos, Servicios, HOCKS.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Node (express)</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de APIs echas con express,
            conectadas con MySQl y MongoDB.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">NestJS</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de APIs echas con express,
            conectadas con MySQl.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Angular 10</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado actualización de conocimiento en Angular.
          </div>
        </div>
      </li>
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">GraphQL</span>
            <span class="time-wrapper">
              <span class="time">2021</span>
            </span>
          </div>
          <div class="desc">
            Curso Virtual enfocado en el desarrollo de manejo de APIs con
            GraphQL.
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Estudios",
};
</script>
<style lang="scss">
@import "../assets/expetiencia.scss";
</style>